<form [formGroup]="mainForm">
  <h1>{{ orgCampaignDetails.Description }}</h1>
  <div class="p-grid p-fluid no-margin">
    <div class="col-md-6 col-sm-6 col-xs-12 margin-top-10">
      <label>First Name<sup class="req">*</sup></label>
      <input class="margin-bottom-5" formControlName="firstName" pInputText type="text"/>
      @if (mainForm.get('firstName').dirty && mainForm.get('firstName').errors?.required) {
        <span class="p-error">First Name is required</span>
      }
    </div>
    <div class="col-md-6 col-sm-6 col-xs-12 margin-top-10">
      <label>Last Name<sup class="req">*</sup></label>
      <input class="margin-bottom-5" formControlName="lastName" pInputText type="text"/>
      @if (mainForm.get('lastName').dirty && mainForm.get('lastName').errors?.required) {
        <span class="p-error">Last Name is required</span>
      }
    </div>
    <div class="col-md-6 col-sm-6 col-xs-12 margin-top-10">
      <label>Email<sup class="req">*</sup></label>
      <!--        <input type="text" class="margin-bottom-5" pInputText formControlName="email"/>-->
      <input (blur)="validatePii('PrimaryEmailAddress', mainForm.get('email').value)" class="margin-bottom-5" formControlName="email" pInputText tabindex="0" type="text">
      @if (mainForm.get('email').dirty && mainForm.get('email').errors?.required) {
        <span class="p-error">Email is required</span>
      }
      @if (mainForm.get('email').dirty && mainForm.get('email').errors?.email) {
        <span class="p-error">Valid Email is required</span>
      }
    </div>
    <div class="col-md-6 col-sm-6 col-xs-12 margin-top-10">
      <label>Mobile #<sup class="req">*</sup></label>
      <p-inputmask [className]="'form-input no-border'" formControlName="mobile" mask="(999) 999-9999"></p-inputmask>
      @if (mainForm.get('mobile').dirty && mainForm.get('mobile').errors?.required) {
        <span class="p-error">Mobile is required</span>
      }
    </div>
    @if (orgCampaignDetails && contextService.contextObject.tenantName) {
      <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10 p-mb-2">
        <app-address-form-custom (outgoingAddress)="setAddress($event)" [canTabWrite]="true" [incomingAddressMailing]="incomingAddressMailing" [showCategory]="true"
                                 [showCounty]="false" [showZipPlus4]="false"></app-address-form-custom>
      </div>
    }

    @if (this.campaignProfile?.CustomAttributes) {
      @for (cf of orgCampaignDetails.CustomAttributes; track cf.CustomFieldID; let i = $index) {
        <div [ngClass]="{'col-md-6 col-sm-6' : cf.Width === 6, 'col-md-12 col-sm-12' : cf.Width === 12}" class=" col-xs-12 p-mb-2">
          <app-dynamic-custom-fields (closeAddEdit)="updateCustomFieldData(i, $event)" [campaignCustomField]="cf" [canTabWrite]="true" [isCampaign]=" true" [isEdit]="true"></app-dynamic-custom-fields>
        </div>
      }
    }


    @if (orgCampaignDetails.ContributionAmounts?.length > 1) {
      <label>Contribution Amount Per Month<sup class="req">*</sup></label>
      <p-select [options]="amounts" appendTo="body" filter="false" formControlName="contributionAmount"
                optionLabel="description" optionValue="value"></p-select>
    }
    @if (orgCampaignDetails.ContributionAmounts?.length === 1) {
      <div class="contribution">
        Contribution: ${{ orgCampaignDetails.ContributionAmounts[0] }}
      </div>
    }


    <!--      <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10">-->
    <!--        <label>Address<sup class="req">*</sup></label>-->
    <!--        <input type="text" class="margin-bottom-5" pInputText  formControlName="address"/>-->
    <!--      </div>-->
    <!--      <div class="col-md-6 col-sm-6 col-xs-12 margin-top-10">-->
    <!--        <label>Suite, Apt #, etc.</label>-->
    <!--        <input type="text" class="margin-bottom-5" pInputText  formControlName="address2"/>-->
    <!--      </div>-->
    <!--      <div class="col-md-6 col-sm-6 col-xs-12 margin-top-10">-->
    <!--        <label>City<sup class="req">*</sup></label>-->
    <!--        <input type="text" class="margin-bottom-5" pInputText  formControlName="city"/>-->
    <!--      </div>-->
    <!--      <div class="col-md-6 col-sm-6 col-xs-12 margin-top-10">-->
    <!--        <app-select class="full-width" [inputObj]="inputObjState" (emitData)="getStateData($event)">-->
    <!--        </app-select>-->
    <!--      </div>-->
    <!--      <div class="col-md-6 col-sm-6 col-xs-12 margin-top-10">-->
    <!--        <label>Postal Code<sup class="req">*</sup></label>-->
    <!--        <input type="text" class="margin-bottom-5" pInputText  formControlName="zipCode"/>-->
    <!--      </div>-->
    <!--      <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10">-->
    <!--        <label>Are you willing to assist with the campaign?<sup class="req">*</sup></label>-->
    <!--        <app-yes-no-select [isBoolean]="true" (emitData)="updateAssist($event)" [nullable]="false" [selectedValue]="campaignProfile.ProvideAssistance" ></app-yes-no-select>-->
    <!--      </div>-->
    <!--      <div class="col-md-6 col-sm-6 col-xs-12 margin-top-10">-->
    <!--        <label>Job Title<sup class="req">*</sup></label>-->
    <!--        <input type="text" class="margin-bottom-5" pInputText formControlName="jobTitle"/>-->
    <!--        @if (mainForm.get('jobTitle').dirty && mainForm.get('jobTitle').errors?.required) {-->
    <!--          <span class="p-error">Job Title is required</span>-->
    <!--        }-->
    <!--      </div>-->
    <!--      <div class="col-md-6 col-sm-6 col-xs-12 margin-top-10">-->
    <!--        <label>Agency<sup class="req">*</sup></label>-->
    <!--        <input type="text" class="margin-bottom-5" pInputText formControlName="agency"/>-->
    <!--        @if (mainForm.get('agency').dirty && mainForm.get('agency').errors?.required) {-->
    <!--          <span class="p-error">Agency is required</span>-->
    <!--        }-->
    <!--      </div>-->
    <!--      <div class="col-md-6 col-sm-6 col-xs-12 margin-top-10">-->
    <!--        <app-select (emitData)="getWorkLevelData($event)" [inputObj]="inputObjWorkLevel" class="full-width"></app-select>-->
    <!--        @if (mainForm.get('workLevel').dirty && mainForm.get('workLevel').errors?.required) {-->
    <!--          <span class="p-error">Work Level is required</span>-->
    <!--        }-->
    <!--      </div>-->
    <!--      <div class="col-md-6 col-sm-6 col-xs-12 margin-top-10">-->
    <!--        <label>Work Location<sup class="req">*</sup></label>-->
    <!--        <input type="text" class="margin-bottom-5" pInputText formControlName="workLocation"/>-->
    <!--        @if (mainForm.get('workLocation').dirty && mainForm.get('workLocation').errors?.required) {-->
    <!--          <span class="p-error">Work Location is required</span>-->
    <!--        }-->
    <!--      </div>-->

    <div class="next-page-button">
      <p-button (click)="goToNextPage()" [disabled]="mainForm.invalid || isItValid()" label="Next to Billing"/>
    </div>
  </div>
</form>
